import React from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Modal } from '@/components/custom/modal/modal';
import { DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Badge } from '@/components/ui/badge';
import { PlayfulCardButton } from '@/components/custom/playful-card';
import { PATHS } from '@/routes/paths';
import { STATUS_META } from './LiveClassCardTeacher';

const CTA_LABEL = {
  'ao-vivo': 'Entrar na sala',
  agendada: 'Disponível no horário da aula',
  finalizada: 'Aula encerrada'
};

export function LiveClassDetailModal({ liveClass, status, onClose }) {
  const navigate = useNavigate();

  if (!liveClass) return null;

  const meta = STATUS_META[status];
  const isLive = status === 'ao-vivo';

  const start = moment(liveClass['initial-date']);
  const end = moment(liveClass['end-date']);
  const dateLabel = `${start.format('dddd, DD/MM')} · ${start.format('H[h]mm')} às ${end.format('H[h]mm')}`;

  const handleEnterRoom = () => {
    navigate(PATHS.LIVE_CLASSES.DETAIL(liveClass.id));
  };

  return (
    <Modal
      show={Boolean(liveClass)}
      onClose={onClose}
      contentClassName="modal__content-sm"
    >
      <div className="flex flex-col gap-4 p-2">
        <Badge
          variant={meta.badgeVariant}
          className="w-fit rounded-full px-2.5 py-1 text-xs font-bold normal-case"
        >
          {meta.label}
        </Badge>

        <div className="flex flex-col gap-1">
          <DialogTitle className="text-xl font-extrabold">{liveClass.title}</DialogTitle>
          {liveClass.courses?.[0]?.name && <p className="mb-0 text-sm text-neutral-500">{liveClass.courses[0].name}</p>}
        </div>

        <DialogDescription className="mb-0 text-sm font-semibold capitalize text-neutral-dark">{dateLabel}</DialogDescription>

        <PlayfulCardButton
          disabled={!isLive}
          onClick={handleEnterRoom}
        >
          {CTA_LABEL[status]}
        </PlayfulCardButton>
      </div>
    </Modal>
  );
}
